import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
`

const BackgroundContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  background: linear-gradient(to top, #EBEEF3, #F7F9FB);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`

const BackgroundSection = ({ children }) => {
  return (
    <Container>
      <BackgroundContainer>
        {children}
      </BackgroundContainer>
    </Container>
  )
}

export default BackgroundSection
